import { Component, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-image-heatmap',
  templateUrl: './image-heatmap.component.html',
  styleUrls: ['./image-heatmap.component.scss']
})
export class ImageHeatmapComponent implements OnInit, OnDestroy {
  @Input()HEATMAP_HEIGHT: number = 1080;
  @Input()HEATMAP_WIDTH: number = 1920;
  image: string = "";
  overlay:string = "";
  isLoading: boolean = false;
  @Input() set prop(value: any) {
    if (!value) return;
    this.image = value.image;
    this.overlay = value.overlay;
  }



  constructor(private renderer: Renderer2) { }
  ngOnDestroy(): void {
   
  }

  ngOnInit(): void {

  }
  imageLoaded(ev) {
    const img = ev.target;
    const _self = this;
    _self.HEATMAP_HEIGHT = img.clientHeight;
    _self.HEATMAP_WIDTH = img.clientWidth;
    return;

  }
 


}
